module.exports = __webpack_public_path__ + "static/media/patient-story-avatar-james.a3413099.svg";